import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SimulatorPage from "@/pages/SimulatorPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SimulatorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
